<template>
    <div>
        <template v-for="(index) in 20">
            <b-form-group :label="`Level ${index}`"
                          label-size="sm"
                          :label-cols-sm="1">
                <b-form-input v-model.number="value[index-1]" type="number"></b-form-input>
            </b-form-group>
        </template>

    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp],
}
</script>

<style scoped>

</style>
